import { createRouter, createWebHistory } from "vue-router";
import HomeBooking from "../components/HomeBooking.vue";
import ShopBooking from "../components/ShopBooking.vue";
import AdminPanel from "../components/AdminPanel.vue";
import AdminAddShopPanel from "../components/AdminAddShopPanel.vue";
import UserSuperAdmin from "../components/UserSuperAdmin.vue";
import UserManagement from "../components/UserManagement.vue";
import LoginBooking from "../components/LoginBooking.vue";
import { auth } from "../firebase/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import ShopBookingApprove from '../views/ShopBookingApprove.vue'
import TrashBin from '../views/TrashBin.vue'
import TempPayments from '../views/TempPayments.vue'
import ShopConfig from '../views/ShopConfig.vue'

// Define Routes
const routes = [
  { path: "/", component: HomeBooking },
  { path: "/booking", component: ShopBooking },
  { path: "/login", component: LoginBooking },
  {
    path: "/admin",
    component: AdminPanel,
    meta: { requiresAuth: true }, // Protect Admin Route
  },
  {
    path: "/add-shop",
    component: AdminAddShopPanel,
    meta: { requiresAuth: true }, // Protect Admin Route
  },
  {
    path: "/user-manage",
    component: UserManagement,
    meta: { requiresAuth: true }, // Protect Admin Route
  },
  {
    path: "/user-admin",
    component: UserSuperAdmin,
    meta: { requiresAuth: true }, // Protect Admin Route
  },
  {
    path: '/booking/payment/:bookingCode?',
    name: 'booking-payment',
    component: () => import('@/views/BookingPayment.vue'),
    props: true
  },
  {
    path: '/booking/confirmation/:bookingCode',
    name: 'booking-confirmation',
    component: () => import('@/views/BookingConfirmation.vue'),
    props: true
  },
  {
    path: '/booking/checkout/:bookingCode',
    name: 'booking-checkout',
    component: () => import('../views/BookingCheckout.vue'),
    props: true
  },
  // Add a route for My Bookings
  {
    path: '/bookings',
    name: 'my-bookings',
    component: () => import('@/views/MyBookings.vue')
  },
  // Add a route to handle the paymentPage endpoint
  {
    path: '/paymentPage',
    name: 'payment-page',
    component: () => import('@/views/BookingPayment.vue'),
    props: (route) => ({
      initialBookingCode: route.query.booking,
      initialAmount: route.query.amount,
      initialSenderId: route.query.senderId,
      initialPageId: route.query.pageId,
      initialBookingType: route.query.type,
      initialBookingDate: route.query.date,
      initialBookingTime: route.query.time,
      initialBankName: route.query.bankName || 'Kasikorn Bank',
      initialAccountName: route.query.accountName || 'Company Name',
      initialAccountNumber: route.query.accountNumber || '123-4-56789-0'
    })
  },
  // Add a route to handle the confirmPayment endpoint 
  {
    path: '/confirmPayment',
    name: 'confirm-payment',
    component: () => import('@/views/PaymentConfirmation.vue'),
    props: (route) => ({
      bookingCode: route.query.booking,
      senderId: route.query.senderId,
      pageId: route.query.pageId
    })
  },
  // Add a route for public booking view (no authentication required)
  {
    path: '/view-booking',
    name: 'view-booking',
    component: () => import('@/views/PublicBookingViewPage.vue'),
    props: (route) => ({
      bookingCode: route.query.code
    })
  },
  {
    path: '/booking',
    component: ShopBooking,
    children: [
      {
        path: 'approve',
        component: ShopBookingApprove
      },
      {
        path: 'trash',
        component: TrashBin
      },
      {
        path: 'temp-payments',
        component: TempPayments
      },
      {
        path: 'config',
        component: ShopConfig
      }
    ]
  },
];

// Create Router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 🔹 Fix Async Authentication in Navigation Guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    return new Promise((resolve) => {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          resolve(next()); // ✅ Allow access
        } else {
          alert("❌ Access Denied! Please log in as an admin.");
          resolve(next("/login")); // ❌ Redirect to login
        }
      });
    });
  } else {
    next(); // ✅ No authentication required
  }
});

export default router;
